import React from 'react';
import PropTypes from 'prop-types';
import { TimelineMaintenanceBase } from './TimelineMaintenance.styles';
import { TurbineReleaseChartRowHeader } from './TurbineReleaseChartRowHeader';
import { TurbineReleaseChartVictory } from './TurbineReleaseChartVictory';
import { WithScroller } from 'lib/components/Scroller/WithScroller';
import { useRematchSelector } from 'models/rematchStore';

export const TurbineReleaseChart = ({ chartWidth, theme }) => {
    const headerWidth = 500;
    const chartMinWidth = 1000;
    const chartMaxWidth = 2000;
    const useScroller = chartWidth <= chartMinWidth;
    const childChartWidth = useScroller ? chartMaxWidth : chartWidth;
    const { timelineData } = useRematchSelector((state) => state.turbineMaintenance);

    return (
        <TimelineMaintenanceBase data-testid="timeline-release-chart">
            <WithScroller useScroller={useScroller}>
                {() => (
                    <>
                        <TurbineReleaseChartRowHeader width={headerWidth} chartWidth={childChartWidth} />
                        <TurbineReleaseChartVictory
                            chartWidth={childChartWidth}
                            timelineData={timelineData}
                            itemLabelWidth={headerWidth}
                            theme={theme}
                        />
                    </>
                )}
            </WithScroller>
        </TimelineMaintenanceBase>
    );
};

TurbineReleaseChart.displayName = 'TurbineReleaseChart';

TurbineReleaseChart.propTypes = {
    chartWidth: PropTypes.number,
};

TurbineReleaseChart.defaultProps = {};
